var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareBubbleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 15,
    viewBox: "0 0 31 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2841 15C4.88872 15 0.609648 5 0.144531 0H30.1445C17.8655 0 17.1213 10 18.2841 15Z",
    fill: "#C0E0BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareBubbleGreen);
export default __webpack_public_path__ + "static/media/hugcare-bubble_green.ed7b36ace006476e42f1b5da9be315aa.svg";
export { ForwardRef as ReactComponent };